import React from 'react'
import { Button } from '@noissue-ui-kit/oldBranding/button'
import { ContentfulNextJsImage } from '@components/common/ContentfulImage'
import { IImage } from '@utils/contentful/contentfulImage'
import { ContentfulMarkdown } from '@utils/contentful/ContentfulMarkdown'
export interface INoissuePlusSectionData {
  title: string
  description: string
  ctaLink: string
  ctaLabel: string
  image: IImage
}

export const NoissuePlusSection = ({
  image,
  title,
  description,
  ctaLink,
  ctaLabel,
}: INoissuePlusSectionData) => {
  if (!title && !description) {
    return null
  }
  return (
    <div className="mx-auto bg-unbleached-60 rounded-4xl flex flex-col justify-between sm:flex-row overflow-hidden">
      <div className="flex flex-col justify-center px-8 pt-16 pb-12 text-center sm:text-left sm:px-32 text-acai sm:py-16 sm:w-7/12 h-48 sm:h-96">
        {title && (
          <ContentfulMarkdown overrideClass="mb-4 text-3xl md:text-[26px] !leading-tight font-semibold text-acai">
            {title}
          </ContentfulMarkdown>
        )}

        {description && (
          <ContentfulMarkdown overrideClass="mb-8 text-2xl text-acai">
            {description}
          </ContentfulMarkdown>
        )}

        {ctaLabel && ctaLink && (
          <Button
            variant="primary"
            size="l"
            corners="square"
            className="sm:max-w-xs"
            href={ctaLink}
            Component="a"
          >
            {ctaLabel}
          </Button>
        )}
      </div>

      <div className="flex justify-end sm:w-5/12 h-48 sm:h-96">
        {image?.imageUrl && (
          <ContentfulNextJsImage
            src={image?.imageUrl}
            alt={image?.imageTitle}
            width={600}
            height={450}
            backgroundColour={'#D9D9E3'}
            fit="pad"
            quality={90}
            format="jpg"
          />
        )}
      </div>
    </div>
  )
}
